export const MESSAGE_TEMPLATES = [
  {
    id: "basic",
    label: "기본 안내",
    message:
      "요청해주신 내용을 바탕으로 견적을 준비했습니다. 자세한 내용은 견적서를 확인해 주세요.",
  },
  {
    id: "visit",
    label: "방문 상담",
    message:
      "요청해주신 조건에 맞춰 견적을 준비했습니다. 매장 방문 시 실제 제품을 비교해 보며 자세히 안내드리겠습니다.",
  },
  {
    id: "custom",
    label: "맞춤 제안",
    message:
      "고객님의 예산과 요청사항을 반영해 맞춤 견적을 준비했습니다. 디자인과 구성은 상담 후 조정 가능합니다.",
  },
  {
    id: "style-recommendation",
    label: "스타일 추천(명품 카피 커스텀 제작 요청시)",
    message:
      "해당 제품과 동일한 디자인으로 제작은 어렵지만, 고객님께서 선호하시는 스타일과 취향을 바탕으로 매장에서 다양한 디자인을 추천해 드릴 수 있습니다.",
  },
  {
    id: "design-proposal",
    label: "디자인 제안(명품 카피 커스텀 제작 요청시)",
    message:
      "특정 제품과 동일한 디자인으로 제작은 어렵지만, 고객님께서 선호하시는 디자인의 무드와 디테일을 바탕으로 취향에 어울리는 디자인을 제안해 드릴 수 있습니다.",
  },
  {
    id: "benefit",
    label: "혜택 안내",
    message:
      "요청하신 견적을 보내드립니다. 예약 후 방문하시면 현재 제공 중인 혜택과 추가 상담을 함께 안내드리겠습니다.",
  },
];

export function createEstimateDetailState() {
  return {
    estimate: null,
    loading: true,
    messageTemplates: MESSAGE_TEMPLATES,
    selectedTemplateId: MESSAGE_TEMPLATES[0].id,
    replyForm: {
      price: "",
      period: "",
      description: MESSAGE_TEMPLATES[0].message,
      images: [],
      preferredProductPrices: [],
      products: [],
    },
    submitting: false,
    editingReply: false,
    uploadingProductImage: false,
    savingPreferredProductPrices: false,
  };
}
